import { Link } from "react-router-dom";
export default function Chooseus() {
    return (
        <>
            <section className="why-chooseus-1-section">
                <div className="auto-container">
                    <div className="row">
                        <div className="col-lg-6 pe-lg-5">
                            <div className="section_heading mb_20">
                                <span className="section_heading_title_small">Why Choose Us</span>
                                <h2 className="section_heading_title_big">Why Most of The People <br /> <span>Choose Shacare</span></h2>
                            </div>
                            <p className="why-chooseus-1-text"></p>
                            <div className="">
                                <div className="why-chooseus-1-block d-flex">
                                    <div className="why-chooseus-1-count">1</div>
                                    <div className="why-chooseus-1-content flex-grow-1">
                                        <h4 className="why-chooseus-1-title mb_15">Personalized Care</h4>
                                        <p className="why-chooseus-1-text2">Shacare Support provides tailored services to meet the unique needs of each <br/> individual, ensuring the highest level of care and support for people with <br/> disabilities. Whether it's assistance with daily activities or complex health<br/>conditions, our team is dedicated to helping participants achieve their goals <br/>and live as independently as possible.<br/></p>
                                    </div>
                                </div>
                                <div className="why-chooseus-1-block d-flex">
                                    <div className="why-chooseus-1-count">2</div>
                                    <div className="why-chooseus-1-content flex-grow-1">
                                        <h4 className="why-chooseus-1-title mb_15">Experienced and Qualified Staff</h4>
                                        <p className="why-chooseus-1-text2">Our team consists of highly trained professionals, including personal support workers, nurses, and specialists, all committed to<br/>  providing compassionate care. We employ only qualified and experienced staff who are equipped to handle the specific needs<br/> of each participant, ensuring their safety, dignity, and well-being.</p>
                                    </div>
                                </div>
                                <div className="why-chooseus-1-block d-flex">
                                    <div className="why-chooseus-1-count">3</div>
                                    <div className="why-chooseus-1-content flex-grow-1">
                                        <h4 className="why-chooseus-1-title mb_15">Comprehensive Range of Services</h4>
                                        <p className="why-chooseus-1-text2">Shacare offers a wide range of services under the NDIS, including personal <br/> assistance, community participation, transport support, and daily living skills<br/>development. Our diverse service offerings ensure that all aspects of a<br/>participant’s life are supported, empowering them to live a more fulfilling <br/>and independent life within their community.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="why-chooseus-1-image text-lg-end">
                                <div className="why-chooseus-1-shape"><img src="assets/images/shape/pattern-1.png" alt=""/></div>
                                <img src="assets/images/Chooseus/Why_Choose_Us.png" alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
